import { useEffect, useState } from 'react';
import { matchPrefersReducedMotion, REDUCED_MOTION_MQ } from 'style/styled-components/cssMediaQueries';

export const usePrefersReducedMotion = () => {
    const [prefersReducedMotion, setPrefersReducedMotion] = useState(() => matchPrefersReducedMotion());

    useEffect(() => {
        const mediaQuery = window.matchMedia(REDUCED_MOTION_MQ);
        const handleChange = () => setPrefersReducedMotion(mediaQuery.matches);

        handleChange();

        mediaQuery.addEventListener('change', handleChange);
        return () => mediaQuery.removeEventListener('change', handleChange);
    }, []);

    return prefersReducedMotion;
};
